module.exports = __webpack_public_path__ + "media/images/album-tracks-00f7e416e91b047904c98b00c269cc7f.svg";